// Theme configuration for multi-tenant branding
// This configuration allows easy customization of logos, colors, and other branding elements per tenant

const themes = {
  initio: {
    logo: 'initio-logo.svg',
    logoType: 'svg',
    favicon: 'favicon.ico',
    colors: {}, // Ready for future color customization
    name: 'Initio',
    title: 'Initio Software',
    supportEmail: 'info@initio.software',
    brandName: 'initio',
  },
  redwoodseed: {
    logo: 'redwoodseed-logo.png',
    logoType: 'png',
    favicon: 'redwoodlogo.png',
    colors: {}, // Ready for future color customization
    name: 'Redwood Seed',
    title: 'Redwood Valuation',
    supportEmail: 'info@redwoodvaluation.com',
    brandName: 'redwood',
  },
};

export default themes;

